import { Module } from 'vuex'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'
import { ReportsState } from '@/store/modules/report/types'
import { ReportModel } from '@/models/interfaces/report.model'
import { SubscribedReportModel } from '@/models/interfaces/subscribedReport.model'

const state: ReportsState = {
  currentIndex: 0 as number,
  customerId: '' as string,
  reports: [] as ReportModel[],
  subscriberReport: {} as SubscribedReportModel,
  selectedReport: {} as ReportModel,
  loading: false
}

export const reports: Module<ReportsState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
